<template>
  <div v-show="$attrs.type !== 'hidden'">
    <v-text-field
      v-model="innerValue"
      :error-messages="errorMessages"
      :success="showSuccess && !errorMessages.length"
      :rules="computedRules"
      v-bind="$attrs"
      v-on="$listeners"
      outlined
      :class="{
        'readonly-input': $attrs.readonly
      }"
    />
  </div>
</template>

<script>
export default {
  props: {
    rules: {
      type: [Array, String],
      default: () => [],
    },
    value: {
      default: null,
    },
    showSuccess: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    computedRules() {
      const rulesArray = Array.isArray(this.rules) ? this.rules : [this.rules];
      // Add required rule if needed
      return [
        (v) => !!v || `${this.$attrs.label || 'Field'} is required`,
        ...rulesArray,
      ];
    },
    errorMessages() {
      // Check if the field is required and empty
      return this.computedRules
        .map((rule) => rule(this.innerValue))
        .filter((message) => message !== true);
    },
  },
};
</script>

<style scoped>
.text-field::v-deep .v-messages.error--text {
  margin-bottom: 16px;
}

.text-field::v-deep .v-messages {
  min-height: 0;
}

.text-field::v-deep .v-text-field__details {
  min-height: 0;
}

.no-error-margin::v-deep .v-messages.error--text {
  margin-bottom: 0px;
}
</style>
